import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ThemeColorsService } from '../../../core/services/theme-colors/theme-colors.service';
import { CachedContent } from '../../../interfaces/cached-content';
import { CacheService } from '../../../ssr-services/cache/cache.service';
import { SsrHtmlInjectorService } from '../../../ssr-services/ssr-html-injector/ssr-html-injector.service';

export const injectSsrContentGuard: CanActivateFn = () => {
  const cacheService = inject(CacheService);
  const ssrHtmlInjection = inject(SsrHtmlInjectorService);
  const themeColorsService = inject(ThemeColorsService);

  const platform = inject(PLATFORM_ID);

  if (isPlatformServer(platform)) {
    const cacheContent = cacheService.cachedContent();
    if (!cacheContent) {
      console.log('failed no cache content');
    }

    ssrHtmlInjection.appendGoogleTagManager(cacheContent?.cache?.config?.gtmId || '');
    ssrHtmlInjection.appendBucketPrefetchUrl(
      cacheContent?.cache.config.webAppConfig.s3BucketAssets || ''
    );

    // check if
    themeColorsService.injectToHtml(cacheContent ? injectThemeColors(cacheContent) : undefined);
  }

  return true;
};

export const injectThemeColors = (cacheContent: CachedContent) => {
  if (!environment.previewMode) {
    return cacheContent?.cache.config.webAppConfig.colors || undefined;
  }

  const previewColors = cacheContent?.cache.config.webAppConfig.colorsPreview || undefined;
  if (!previewColors) {
    return cacheContent?.cache.config.webAppConfig.colors || undefined;
  }

  const colors = cacheContent?.cache.config.webAppConfig.colors || {};

  for (const key in colors) {
    previewColors[key] = previewColors[key] || colors[key];
  }

  return previewColors;
};
